__turbopack_context__.v({
  "banner": "index-module-scss-module__UUfK7G__banner",
  "btn": "index-module-scss-module__UUfK7G__btn",
  "card": "index-module-scss-module__UUfK7G__card",
  "doubleBanner": "index-module-scss-module__UUfK7G__doubleBanner",
  "doubleBanner_wrap": "index-module-scss-module__UUfK7G__doubleBanner_wrap",
  "grid": "index-module-scss-module__UUfK7G__grid",
  "gridSection": "index-module-scss-module__UUfK7G__gridSection",
  "grid__item_banner": "index-module-scss-module__UUfK7G__grid__item_banner",
  "grid__item_banner_mob": "index-module-scss-module__UUfK7G__grid__item_banner_mob",
  "main": "index-module-scss-module__UUfK7G__main",
  "mainTitle": "index-module-scss-module__UUfK7G__mainTitle",
  "mt": "index-module-scss-module__UUfK7G__mt",
  "note": "index-module-scss-module__UUfK7G__note",
  "row": "index-module-scss-module__UUfK7G__row",
  "section": "index-module-scss-module__UUfK7G__section",
  "sectionTitle": "index-module-scss-module__UUfK7G__sectionTitle",
  "section_db": "index-module-scss-module__UUfK7G__section_db",
  "steps": "index-module-scss-module__UUfK7G__steps",
  "stepsTitle": "index-module-scss-module__UUfK7G__stepsTitle",
  "wideBanner": "index-module-scss-module__UUfK7G__wideBanner",
});
